var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMakefunnelsLogoY(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Camada_1",
    "data-name": "Camada 1",
    viewBox: "38.58 38.58 309.77 203.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#000038;}.cls-2{fill:url(#Gradiente_sem_nome_6);}.cls-3{fill:url(#Gradiente_sem_nome_13);}.cls-4{fill:url(#Gradiente_sem_nome_14);}.cls-5{fill:url(#Gradiente_sem_nome_15);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_6",
    x1: 173.27,
    y1: 100.67,
    x2: 174.25,
    y2: 100.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9d2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff2a87"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_13",
    x1: 92.55,
    y1: 57.8,
    x2: 284.35,
    y2: 57.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#ff9d2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#ff2a87"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_14",
    x1: 142.82,
    y1: 120.04,
    x2: 236.3,
    y2: 120.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#ff9d2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#ff635b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff2a87"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_15",
    x1: 178.85,
    y1: 157.48,
    x2: 225.65,
    y2: 125.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#ff2a87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#c90059"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.58,240.79V206.34h8.27l11,20.27,11-20.27h8.26v34.45H69.93v-22.1l-9.3,16.54H55.07l-9.25-16.49v22Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M92.76,241.23a10.44,10.44,0,0,1-8.12-3.64,14.11,14.11,0,0,1,0-18A10.48,10.48,0,0,1,92.76,216a9.93,9.93,0,0,1,8,3.49v-3h6.9v24.36h-6.9v-3A10,10,0,0,1,92.76,241.23ZM90,233.31a6.23,6.23,0,0,0,8.93,0,7,7,0,0,0,0-9.4,6.24,6.24,0,0,0-8.93,0,7.13,7.13,0,0,0,0,9.45Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M112.6,240.79V203.88h6.89V225h3.69l6.93-8.56h8.62l-9.94,11.81,9.94,12.55h-8.47l-7.08-9.25h-3.69v9.25Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M152.46,215.64a11.94,11.94,0,0,1,8.83,3.42q3.42,3.42,3.47,9.43c0,.85,0,1.52,0,2H146a6.25,6.25,0,0,0,2.27,3.94,6.59,6.59,0,0,0,4.18,1.38,7.38,7.38,0,0,0,6.2-2.81l4.18,3.5a11.23,11.23,0,0,1-4.48,3.61,13.72,13.72,0,0,1-5.85,1.31,12.66,12.66,0,0,1-12.9-12.8,12.68,12.68,0,0,1,3.67-9.27A12.35,12.35,0,0,1,152.46,215.64Zm0,5.37a6.31,6.31,0,0,0-4.06,1.35,6.93,6.93,0,0,0-2.34,3.71h12.45C157.67,222.7,155.66,221,152.51,221Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M168.79,240.79V206.34h24.32v6.45H176v8h16.73v6.35H176v13.68Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M207.33,241.08a9.87,9.87,0,0,1-7.66-3.15c-1.91-2.1-2.88-5.05-2.88-8.85V216.43h6.9v11.91a7.79,7.79,0,0,0,1.45,5.07,4.72,4.72,0,0,0,3.86,1.77,5,5,0,0,0,4.08-1.82,8,8,0,0,0,1.48-5.17V216.43h6.89v24.36h-6.79v-2.95h-.1A8.85,8.85,0,0,1,207.33,241.08Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M226.37,240.79V216.43h6.89v2.9A9.1,9.1,0,0,1,240.5,216a9.79,9.79,0,0,1,7.65,3.19c1.92,2.14,2.88,5.12,2.88,9v12.65h-6.89V228.73a7.85,7.85,0,0,0-1.45-5.07,4.76,4.76,0,0,0-3.87-1.77,4.93,4.93,0,0,0-4.06,1.87,8,8,0,0,0-1.5,5.12v11.91Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M255.6,240.79V216.43h6.89v2.9a9.12,9.12,0,0,1,7.24-3.34,9.79,9.79,0,0,1,7.65,3.19c1.92,2.14,2.88,5.12,2.88,9v12.65h-6.89V228.73a7.79,7.79,0,0,0-1.45-5.07,4.76,4.76,0,0,0-3.87-1.77,4.94,4.94,0,0,0-4.06,1.87,8,8,0,0,0-1.5,5.12v11.91Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M296.4,215.64a11.94,11.94,0,0,1,8.83,3.42q3.42,3.42,3.47,9.43c0,.85,0,1.52-.05,2H290a6.3,6.3,0,0,0,2.27,3.94,6.59,6.59,0,0,0,4.18,1.38,7.37,7.37,0,0,0,6.2-2.81l4.18,3.5a11.2,11.2,0,0,1-4.47,3.61,13.76,13.76,0,0,1-5.86,1.31,12.65,12.65,0,0,1-12.89-12.8,12.67,12.67,0,0,1,3.66-9.27A12.36,12.36,0,0,1,296.4,215.64Zm.05,5.37a6.31,6.31,0,0,0-4.06,1.35,6.93,6.93,0,0,0-2.34,3.71H302.5Q301.18,221,296.45,221Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M320.71,240.89a7.87,7.87,0,0,1-8.51-8.57V203.88h6.88V231a3.32,3.32,0,0,0,1,2.64,3.63,3.63,0,0,0,2.46.86,4.46,4.46,0,0,0,1.38-.2l.69,6A16.29,16.29,0,0,1,320.71,240.89Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M337.29,241.67a13.26,13.26,0,0,1-7-1.84,9.49,9.49,0,0,1-4.21-5l6-1.87a5.28,5.28,0,0,0,5.31,3.2,5.47,5.47,0,0,0,3.1-.76,2.42,2.42,0,0,0,1.13-2.14,1.64,1.64,0,0,0-1-1.55,5.89,5.89,0,0,0-2.44-.57c-.93,0-2.08-.14-3.44-.32a13.63,13.63,0,0,1-3.47-.86,6.36,6.36,0,0,1-4.18-6.2,7,7,0,0,1,2.9-5.71,11,11,0,0,1,7.09-2.31,11.33,11.33,0,0,1,6.57,1.82,8.52,8.52,0,0,1,3.47,4.87l-5.86,1.63a4,4,0,0,0-1.43-2.29,4.16,4.16,0,0,0-2.7-.86,4.42,4.42,0,0,0-2.69.78,2.35,2.35,0,0,0-1.05,1.92,2,2,0,0,0,1.67,1.95,23.69,23.69,0,0,0,4.53.78,16.27,16.27,0,0,1,4.38.91c2.92,1.22,4.38,3.25,4.38,6.11a7.17,7.17,0,0,1-3.1,6A13,13,0,0,1,337.29,241.67Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M174.25,100.69h-1a4,4,0,0,1,1,0Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M284.35,47.44a8.76,8.76,0,0,1-1.56,5l-.15.18-.52.66L268.85,70.47v0l-1.07,1.36c-.23.28-.49.57-.75.83A14.64,14.64,0,0,1,256.84,77H130.67a14.69,14.69,0,0,1-10.44-4.33c-.2-.2-.41-.43-.61-.66l-.69-.87L92.55,38.58H275.49A8.88,8.88,0,0,1,284.35,47.44Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M236.3,109.57a8.78,8.78,0,0,1-1.5,4.94l-.52.69-18.7,24.18a5.88,5.88,0,0,0-4.88-9.17H173.76a14.76,14.76,0,0,1-10.45-4.33c-.34-.35-.66-.69-.95-1l-19.54-24.15h84.62A8.87,8.87,0,0,1,236.3,109.57Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M216.59,136.09a5.85,5.85,0,0,1-1,3.29l-.35.47-16.74,21.67-.34.43a3,3,0,0,1-2.11.87,3,3,0,0,1-3-3V130.21H210.7A5.89,5.89,0,0,1,216.59,136.09Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMakefunnelsLogoY);
export default __webpack_public_path__ + "static/media/makefunnels-logo-y.fc61690a8ceecca8fed1cc7f08e34181.svg";
export { ForwardRef as ReactComponent };